import { render, staticRenderFns } from "./EntityDialog.vue?vue&type=template&id=e530befa&"
import script from "./EntityDialog.vue?vue&type=script&lang=ts&"
export * from "./EntityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports